// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4988":"fedd296e","5036":"7170f1a0","6209":"a9bb215c","7113":"2f6ae00f","8451":"1ace0cb0","9620":"7170f1a0"}[chunkId] + ".chunk.css";
};